import {GET} from "@/services/gateway";

const getBackupsByDay = () => {
  return GET('dashboard/salesforce/backups')
}

export {
  getBackupsByDay,
}
